import React from 'react';
import { Box } from '@match/react-component-library';
import styled from 'packages/theming';

export interface TruncateProps {
  children: React.ReactNode;
  className?: string;
  inline?: boolean;
  width?: number | string;
}

const Truncate: React.FC<TruncateProps> = (props) => {
  return (
    <TruncateBox inline={props.inline || false} className={props.className} maxWidth={props.width}>
      {props.children}
    </TruncateBox>
  );
};

Truncate.defaultProps = {
  width: '100%',
  inline: false,
};

export default Truncate;

const TruncateBox = styled(Box)<{ inline: boolean }>(({ inline }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: inline ? 'table-cell' : 'block', // table-cell gives us what inline does, but allows us to still truncate the text
}));
